import * as Yup from 'yup';
import { MESSAGE_INVALID_LOGIN_IDENTIFIER, MESSAGE_REQUIRED } from '@/utils/validation-utils';
import { emailSchema } from '@/validation/emailSchema';
import { isLoginIdentifierPhone } from '@/utils/phone-utils';

/**
 * Accepts a valid email OR a valid Russian phone (10 national digits).
 * A separate schema so the email-only {@link emailSchema} stays intact for restore and registration.
 */
export const loginIdentifierSchema: Yup.StringSchema = Yup.string()
  .required(MESSAGE_REQUIRED)
  .test('email-or-phone', MESSAGE_INVALID_LOGIN_IDENTIFIER, (value?: string): boolean => {
    if (!value) {
      return false;
    }
    return emailSchema.isValidSync(value) || isLoginIdentifierPhone(value);
  });
